export default __webpack_public_path__ + "static/media/SmallSquare.93e50d8f689031811978d4d8df9fce07.svg";